module.exports = __webpack_public_path__ + "img/friendLink.ce85b6d2.png";